import React from 'react';
import { X } from 'lucide-react';

export function QRModal({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center p-4" style={{ zIndex: 2000 }}>
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="bg-white rounded-2xl w-full max-w-md relative">
        <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between">
          <h2 className="text-xl font-bold text-gray-900">Código QR</h2>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-gray-100">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-6">
          <img
            src="https://storage.googleapis.com/fastmax-images/3217033e-bdbd-4b02-a661-e18a65e031e1-qrImage.png"
            alt="QR Code"
            className="w-full rounded-lg"
          />
        </div>
      </div>
    </div>
  );
}